import React, { useCallback, useContext, useMemo } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Flex, Grid } from "@aws-amplify/ui-react";
import moment from "moment";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";

import { globalStrings } from "config/translations/es";
import { ScheduleContext } from "components/maintenanceSchedules/context/ScheduleContext";

import "moment/locale/es";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./style.css";

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const BigCalendar = () => {
  const {
    events,
    moveEvent,
    createEvent,
    selectEvent,
  } = useContext(ScheduleContext);
  const eventsList = useMemo(
    () => events.list?.map((ev) => ({ ...ev, isDraggable: !ev.isHoliday })) ?? [],
    [events.list]
  );

  const eventPropGetter = useCallback(
    (event) => ({
      ...(event.isDraggable
        ? { className: "isDraggable" }
        : { className: "nonDraggable" }),
    }),
    []
  );

  const components = {
    event: (props) => {
      return (
        <Flex
          direction="column"
          style={{
            rowGap: "5px",
            padding: "5px",
            height: "100%",
            color: "black",
            borderLeft: `5px solid ${props.event.color || "#14547b"}`,
          }}
        >
          <span>{props.title}</span>
          <span>
            {moment(props.event.start).format("HH:mm")} -{" "}
            {moment(props.event.end).format("HH:mm")}
          </span>
        </Flex>
      );
    },
    month: {
      event: (props) => {
        return (
          <Flex
            direction="column"
            style={{
              paddingLeft: "5px",
              color: "black",
              borderLeft: `5px solid ${props.event.color || "#14547b"}`,
            }}
          >
            <span>{props.title}</span>
          </Flex>
        );
      },
    },
  };

  return (
    <Grid>
      <div style={{ opacity: events.loading ? 0.5 : 1 }}>
        <DnDCalendar
          defaultDate={moment().toDate()}
          defaultView="month"
          draggableAccessor="isDraggable"
          eventPropGetter={eventPropGetter}
          events={eventsList}
          localizer={localizer}
          onDropFromOutside={createEvent}
          onEventDrop={moveEvent}
          onEventResize={moveEvent}
          onSelectEvent={selectEvent}
          resizable
          views={["month", "week", "day"]}
          messages={{
            next: globalStrings.next,
            previous: globalStrings.previous,
            today: globalStrings.today,
            month: globalStrings.month,
            week: globalStrings.week,
            day: globalStrings.day,
          }}
          style={{ height: "75vh" }}
          components={components}
        />
      </div>
    </Grid>
  );
};

export default BigCalendar;
